export default {
  Tag: {
    TagListType: {
      Both: { Value: "Both" },
      Own: { Value: "Own" },
      Project: { Value: "Project" },
    },
  },
};
